export class SearchErpVesselRequest {
    public vesselName : string;
}